class RedirectException {
  constructor(fragment) {
    this.fragment = fragment;
  }
}

export default RedirectException;
